import labelTemplates from './defaultLabelTemplates';
import rowTemplateThresholds from './defaultRowTemplateThresholds';

export default {
	decimal: '.',
	thousands: ',',
	grouping: [3],
	currency: ['$', ''],
	dateTime: '%a %b %e %X %Y', // %c
	time: '%-I:%M%p', // 12-hour format
	periods: ['am', 'pm'], // %p
	date: '%Y年%-m月%-d日', // %x
	days: ['日曜日', '月曜', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'], // %A
	shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // %a
	months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], // %B
	shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], // %b
	translations: {
		band: {
			overbought: '買われすぎ',
			oversold: '売られすぎ'
		},
		chart: {
			unavailable: 'チャートを表示できません'
		},
		indicator: {
			previousclose: {
				label: '以前の価格 {0}'
			}
		}
	},
	labelTemplates,
	rowTemplateThresholds
};
